"use strict";

var _regeneratorRuntime = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var penpal_1 = __importDefault(require("penpal"));

var eventemitter3_1 = __importDefault(require("eventemitter3"));

var is_buffer_1 = __importDefault(require("is-buffer"));

var version_1 = __importDefault(require("./version"));

var AuthereumProvider_1 = __importDefault(require("./AuthereumProvider"));

var StarkWareProvider_1 = __importDefault(require("./StarkWareProvider"));

var ZkSyncProvider_1 = __importDefault(require("./ZkSyncProvider"));

var config_1 = require("./config");

var utils_1 = require("./utils"); // Serialize object for postMessage to iframe.
// Converts references to values.


var serializeMessageObj = function serializeMessageObj(obj) {
  var tx = {};

  for (var k in obj) {
    var v = obj[k];

    if (typeof v === 'object' && v.toString === 'function') {
      v = v.toString('hex');
    }

    tx[k] = v;
  }

  return tx;
};

var defaultIframeStyle = {
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  zIndex: 1
};

var noop = function noop() {// noop
}; // This is a placeholder notify object stub until notifier script url is
// injected into page after iframe is loaded.


var defaultNotifier = {
  notify: function notify(type, message) {
    console.debug(type, message);
    return {
      dismiss: noop
    };
  }
};

var constructIframe = function constructIframe(input) {
  var id = input.id,
      url = input.url,
      isPreload = input.isPreload,
      disableGoogleAnalytics = input.disableGoogleAnalytics;
  var parentUrl = window.location.href;

  try {
    parentUrl = parent.document.URL;
  } catch (err) {// noop
  }

  var srcUrl = utils_1.updateQueryParams({
    url: parentUrl,
    isPreload: isPreload,
    disableGoogleAnalytics: disableGoogleAnalytics
  }, url);
  var iframe = document.createElement('iframe');
  iframe.id = id;
  iframe.name = id.replace(/--.*/, '');
  iframe.title = id;
  iframe.src = srcUrl;

  if (['Safari', 'Firefox'].includes(utils_1.browserInfo().browser)) {
    iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
  }

  iframe.style.position = 'fixed';
  iframe.style.bottom = '0';
  iframe.style.right = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.style.background = 'transparent';
  iframe.style.zIndex = "".concat(defaultIframeStyle.zIndex);
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('scrolling', 'no');
  return iframe;
};

var onDomReady = function onDomReady() {
  return new Promise(function (resolve) {
    if (typeof window !== 'undefined') {
      if (document.readyState !== 'loading') {
        resolve();
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          return resolve();
        });
      }
    }
  });
};

var Authereum = /*#__PURE__*/function (_eventemitter3_1$defa) {
  _inherits(Authereum, _eventemitter3_1$defa);

  function Authereum(config) {
    var _this;

    _classCallCheck(this, Authereum);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Authereum).call(this));
    _this._debug = !!utils_1.getQueryParamValue('debug');
    _this._notifier = defaultNotifier;
    _this._cacheReady = false;
    _this._iframeReady = false;
    _this._configReady = false;
    _this._iframeConnecting = null;
    _this._readyEmitted = false;
    _this._widgetEnabled = false;
    _this._iframeStyle = defaultIframeStyle;
    _this._notificationIframeStyle = defaultIframeStyle;
    _this._blockedPopupRedirect = true;
    _this._forceRedirect = false;
    _this._heartbeatStarted = false;
    _this._backoffTimeout = 1;
    _this._userConfig = null;
    _this._asymmetricEncryptionKey = null;
    _this._authereumQueryParams = {};
    _this._injectedElements = [];
    _this._notificationsMap = {};
    _this._destroyed = false;
    _this._starkProvider = null;
    _this._zkSyncProvider = null;
    _this._isPreload = false;
    _this._disableGoogleAnalytics = false;
    _this._eventListeners = []; // NOTE: keep this sync

    _this._init = function (config) {
      _this._initConfig(config);

      _this._iframeStyle = {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        zIndex: 0
      };
      _this._provider = new AuthereumProvider_1.default(_assertThisInitialized(_assertThisInitialized(_this)));

      _this._connectToChildIframe().catch(function () {
        _this._startHeartbeat(true);
      }).catch(function (err) {
        console.warn('ping error:', err.message);
      });

      _this._setupCache().catch(noop);

      _this._cacheAuthereumQueryParams();

      _this._setupSigningKey().catch(noop);

      _this._setupResizeListener();

      _this._setupFocusListener();

      _this._setupActionKeyListener();

      _this._emitReadyEvent();
    }; // NOTE: keep this sync


    _this._initConfig = function (config) {
      if (typeof config === 'string') {
        var network = config;
        _this._networkName = (network || '').trim().toLowerCase();

        if (['mainnet', 'ropsten', 'rinkeby', 'kovan', 'goerli'].includes(_this._networkName)) {
          _this._xsUri = config_1.defaultConfig.xsUri(_this._networkName);
        } else if (config === 'localhost') {
          _this._xsUri = 'http://localhost:3002';
          _this._networkName = 'kovan';
        } else {
          throw new Error('Unsupported network');
        }
      } else {
        config = config || {};
        _this._networkName = config.networkName || 'mainnet';
        _this._xsUri = config.xsUri || config_1.defaultConfig.xsUri(_this._networkName);
        _this._apiKey = config.apiKey;
      }

      if (config.redirectUri) {
        _this._redirectUri = config.redirectUri;
      } else {
        _this._redirectUri = window.location.href;
      }

      _this._redirectUri = _this._redirectUri || window.location.href;
    }; // NOTE: keep this sync


    _this._setConfig = function (config) {
      if (typeof _this._userConfig === 'string') {
        var network = _this._userConfig;
        _this._networkName = (network || '').trim().toLowerCase();
        _this._userConfig = {
          networkName: _this._networkName,
          xsUri: config_1.defaultConfig.xsUri(_this._networkName)
        };
      }

      var _ref = _this._userConfig || {},
          apiKey = _ref.apiKey,
          apiUri = _ref.apiUri,
          rpcUri = _ref.rpcUri,
          webUri = _ref.webUri,
          notifierUri = _ref.notifierUri,
          networkName = _ref.networkName,
          networkId = _ref.networkId,
          disableNotifications = _ref.disableNotifications,
          blockedPopupRedirect = _ref.blockedPopupRedirect,
          forceRedirect = _ref.forceRedirect;

      if (apiKey) {
        _this._apiKey = apiKey;
      } // userConfig overrides regular config


      if (apiUri) {
        _this._apiUri = apiUri;
      } else if (config.apiUri) {
        _this._apiUri = config.apiUri;
      } // userConfig overrides regular config


      if (rpcUri) {
        _this._rpcUri = rpcUri;
      } else if (config.rpcUri) {
        _this._rpcUri = config.rpcUri;
      } // userConfig overrides regular config


      if (webUri) {
        _this._webUri = webUri;
      } else if (config.webUri) {
        _this._webUri = config.webUri;
      } // userConfig overrides regular config


      if (notifierUri) {
        _this._notifierUri = notifierUri;
      } else if (config.notifierUri) {
        _this._notifierUri = config.notifierUri;
      } // userConfig overrides regular config


      if (networkName) {
        _this._networkName = networkName;
      } else if (config.networkName) {
        _this._networkName = config.networkName;
      } // userConfig overrides regular config


      if (networkId) {
        _this._networkId = networkId;
      } else if (config.networkId) {
        _this._networkId = config.networkId;
      } // userConfig overrides regular config


      if (typeof disableNotifications === 'boolean') {
        _this._disableNotifications = disableNotifications;
      } else if (typeof config.disableNotifications === 'boolean') {
        _this._disableNotifications = config.disableNotifications;
      } // userConfig overrides regular config


      if (typeof blockedPopupRedirect === 'boolean') {
        _this._blockedPopupRedirect = blockedPopupRedirect;
      } else if (typeof config.blockedPopupRedirect === 'boolean') {
        _this._blockedPopupRedirect = config.blockedPopupRedirect;
      } // userConfig overrides regular config


      if (typeof forceRedirect === 'boolean') {
        _this._forceRedirect = forceRedirect;
      } else if (typeof config.forceRedirect === 'boolean') {
        _this._forceRedirect = config.forceRedirect;
      }
    };

    _this._setupCache = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all([this._cacheLoginKeyAddress(), this._cacheIsAuthenticated(), this._cacheAccountAddress()]);

              case 2:
                this._cacheReady = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    _this._handleWindowFocus = function () {
      if (_this._destroyed) {
        return;
      }

      if (!_this._bodyContainsIframe()) {
        return;
      }

      return _this._postMessageToChild({
        method: 'onWindowFocus'
      });
    };

    _this._resetCache = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._setupCache());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    _this._injectScript = function (sourceUrl) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._tilDomReady();

              case 2:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  if (!sourceUrl) {
                    throw new Error('sourceUrl is required');
                  }

                  if (document.getElementById(id)) {
                    resolve();
                    return;
                  }

                  var script = document.createElement('script');
                  script.id = id;
                  script.type = 'text/javascript';
                  script.async = true;

                  script.onload = function () {
                    resolve();
                  };

                  script.onerror = function (err) {
                    reject(err);
                  };

                  script.src = sourceUrl;

                  _this2._injectedElements.push(script);

                  document.getElementsByTagName('head')[0].appendChild(script);
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };

    _this._setupResizeListener = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.addEventListener('resize', this._handleResizeThrottled, false);
                this.addEventListener('resize', this._handleResizeDebounced, false);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };

    _this._handleActionKeyPress = function (event) {
      if (_this._destroyed) {
        return;
      }

      if (!_this._bodyContainsIframe()) {
        return;
      }

      var keyName = '';

      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        keyName = 'escape';
      } else if (event.key === 'Enter' || event.keyCode === 13) {
        keyName = 'enter';
      } else if (event.key === 'ArrowLeft' || event.keyCode === 37) {
        keyName = 'left';
      } else if (event.key === 'ArrowUp' || event.keyCode === 38) {
        keyName = 'up';
      } else if (event.key === 'ArrowRight' || event.keyCode === 39) {
        keyName = 'right';
      } else if (event.key === 'ArrowDown' || event.keyCode === 40) {
        keyName = 'down';
      }

      if (keyName) {
        return _this._postMessageToChild({
          method: 'actionKeyPress',
          params: keyName
        });
      }
    };

    _this._handleResize = function (event) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var size;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this._destroyed) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                if (this._bodyContainsIframe()) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                _context5.next = 6;
                return this._getWindowSize();

              case 6:
                size = _context5.sent;
                return _context5.abrupt("return", this._postMessageToChild({
                  method: 'onResize',
                  params: size
                }));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };

    _this._handleResizeThrottled = utils_1.throttle(function (event) {
      return _this._handleResize(event);
    }, 10);
    _this._handleResizeDebounced = utils_1.debounce(function (event) {
      return _this._handleResize(event);
    }, 10);

    _this._cacheLoginKeyAddress = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var loginKey;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._postMessageToChild({
                  method: 'getOrCreateLoginKey'
                });

              case 2:
                loginKey = _context6.sent;
                this._cachedLoginKeyAddress = loginKey.publicAddress;

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    };

    _this._cacheAccountAddress = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._postMessageToChild({
                  method: 'getAccountAddress'
                });

              case 2:
                accountAddress = _context7.sent;
                this._cachedAccountAddress = accountAddress;

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    };

    _this._cacheIsAuthenticated = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var isAuthenticated;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._postMessageToChild({
                  method: 'isAuthenticated'
                });

              case 2:
                isAuthenticated = _context8.sent;
                this._cachedIsAuthenticated = isAuthenticated;

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }; // NOTE: to prevent pop-ups from being blocked, there must be no awaits from
    // click to window.open, meaning value lookups must be cached before the
    // login method is called.


    _this.login = utils_1.throttle(function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this3 = this;

        var isIframeReady, isConfigReady, account;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                isIframeReady = this._iframeReady && this._cacheReady;
                isConfigReady = this._configReady; // these are false when dapp calls login immediately on page load
                // so we're forced to wait here.

                if (isIframeReady && isConfigReady) {
                  _context9.next = 7;
                  break;
                }

                _context9.next = 5;
                return this._tilConfigReady();

              case 5:
                _context9.next = 7;
                return this._tilReady();

              case 7:
                if (this._cachedIsAuthenticated) {
                  _context9.next = 13;
                  break;
                }

                _context9.next = 10;
                return this._signLoginKeyRequest(this._cachedLoginKeyAddress);

              case 10:
                return _context9.abrupt("return", this.getAuthenticatedAccount());

              case 13:
                // only show one already logged in notification at a time
                if (!this._notificationsMap['loggedIn']) {
                  this._postMessageToChild({
                    method: 'notification',
                    params: {
                      type: 'success',
                      message: 'You are logged into Authereum',
                      timeout: 5e3
                    }
                  }).catch(noop);

                  this._notificationsMap['loggedIn'] = true;
                  setTimeout(function () {
                    _this3._notificationsMap['loggedIn'] = null;
                  }, 5e3);
                }

              case 14:
                _context9.next = 16;
                return this.getAuthenticatedAccount();

              case 16:
                account = _context9.sent;
                return _context9.abrupt("return", account);

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }, 250);

    _this.authenticate = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.authenticate()` is deprecated. Use `authereum.login()` instead.');
                return _context10.abrupt("return", this.login());

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    };

    _this.isAuthenticated = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'isAuthenticated'
                })));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    };

    _this.logout = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var res;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._postMessageToChild({
                  method: 'logout'
                });

              case 2:
                res = _context12.sent;
                _context12.next = 5;
                return this._resetCache();

              case 5:
                this.emit('logout', {});
                return _context12.abrupt("return", res);

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    };

    _this.getAuthenticatedAccount = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getAuthenticatedAccount'
                })));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    };

    _this.getDappKey = function () {
      return _this._handleError(_this._postMessageToChild({
        method: 'getLoginKey'
      }));
    };

    _this.getLoginKey = function () {
      console.warn('Deprecation notice: `authereum.getLoginKey()` is deprecated. Use `authereum.getDappKey()` instead.');
      return _this.getDappKey();
    };

    _this.signMessage = utils_1.throttle(function (message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'signMessage',
                  params: [message, options]
                })));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }, 250);
    _this.signPersonalMessage = utils_1.throttle(function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'signMessage',
                  params: [message, {
                    personal: true
                  }]
                })));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }, 250);
    _this.signWithDappKey = utils_1.throttle(function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.signWithDappKey()` is deprecated. Use `authereum.signMess()` instead.');
                return _context16.abrupt("return", this.signMessage(message));

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }, 250);
    _this.signWithLoginKey = utils_1.throttle(function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.signWithLoginKey()` is deprecated. Use `authereum.signWithDappKey()` instead.');
                return _context17.abrupt("return", this.signWithDappKey(message));

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }, 250);
    _this.signTypedMessage = utils_1.throttle(function (message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.signTypedMessage()` is deprecated. Use `authereum.signMessage()` instead.');
                return _context18.abrupt("return", this.signMessage(message, options));

              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }, 250);
    _this.signTypedMessageWithDappKey = utils_1.throttle(function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.signTypedMessageWithDappKey()` is deprecated. Use `authereum.signMessage()` instead.');
                return _context19.abrupt("return", this.signTypedMessage(message));

              case 2:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }, 250);
    _this.signMessageWithAdminKey = utils_1.throttle(function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.signMessageWithAdminKey()` is deprecated. Use `authereum.signMessageWithSigningKey()` instead.');
                return _context20.abrupt("return", null);

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));
    }, 250);
    _this.signMessageWithSigningKey = utils_1.throttle(function (message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'signMessageWithSigningKey',
                  params: [message, options]
                })));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }, 250);

    _this.getSigningKeyAddress = function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getSigningKeyAddress'
                })));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    };

    _this.getLoginKeyAuthSignature = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getLoginKeyAuthSignature'
                })));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    };

    _this.getLoginKeyRestrictionsData = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getLoginKeyRestrictionsData'
                })));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    };

    _this.getSigningKeyAuthSignature = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getSigningKeyAuthSignature'
                })));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
    };

    _this.getAccountAddress = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this._tilReady();

              case 2:
                return _context26.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getAccountAddress'
                })));

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
    };

    _this.getBalance = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getBalance'
                })));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    };

    _this.getRpcUri = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this._tilConfigReady();

              case 2:
                return _context28.abrupt("return", this._rpcUri);

              case 3:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    };

    _this.getNetworkId = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getNetworkId'
                })));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
    };

    _this.getNetworkName = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                return _context30.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getNetworkName'
                })));

              case 1:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    };

    _this.getCachedNetworkName = function () {
      return _this._networkName;
    };

    _this.getProvider = function () {
      return _this._provider;
    };

    _this.getStarkProvider = function () {
      if (!_this._starkProvider) {
        _this._starkProvider = new StarkWareProvider_1.default(_assertThisInitialized(_assertThisInitialized(_this)));
      }

      return _this._starkProvider;
    };

    _this.getZkSyncProvider = function () {
      if (!_this._zkSyncProvider) {
        _this._zkSyncProvider = new ZkSyncProvider_1.default(_assertThisInitialized(_assertThisInitialized(_this)));
      }

      return _this._zkSyncProvider;
    };

    _this._handleError = function (promise) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", promise.catch(function (err) {
                  // NOTE: emit errors but don't throw notification here.
                  _this4.emit('error', err); // NOTE: rethrow error to let dapps handle error


                  // NOTE: rethrow error to let dapps handle error
                  throw err;
                }));

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));
    };

    _this.signTransaction = utils_1.throttle(function (tx) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this._tilReady();

              case 2:
                return _context32.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'signTransaction',
                  params: serializeMessageObj(tx)
                })));

              case 3:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));
    }, 250);
    _this.signTransactionWithLoginKey = utils_1.throttle(function (tx) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.signTransactionWithLoginKey()` is deprecated. Use `authereum.signTransaction()` instead.');
                return _context33.abrupt("return", this.signTransaction(tx));

              case 2:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));
    }, 250);
    _this.sendTransaction = utils_1.throttle(function (userTransaction) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return this._tilReady();

              case 2:
                return _context34.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'sendTransaction',
                  params: serializeMessageObj(userTransaction)
                })));

              case 3:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
    }, 250);
    _this.sendTransactionBatch = utils_1.throttle(function (userTransactions) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return this._tilReady();

              case 2:
                return _context35.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'sendTransactionBatch',
                  params: userTransactions.map(serializeMessageObj)
                })));

              case 3:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));
    }, 250);

    _this.estimateGas = function (userTransaction) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return this._tilReady();

              case 2:
                return _context36.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'estimateGasBatch',
                  params: serializeMessageObj(userTransaction)
                })));

              case 3:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));
    };

    _this.estimateGasBatch = function (userTransactions) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return this._tilReady();

              case 2:
                return _context37.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'estimateGasBatch',
                  params: userTransactions.map(serializeMessageObj)
                })));

              case 3:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));
    };

    _this.isReady = function () {
      return _this._iframeReady && _this._cacheReady;
    };

    _this.updateConfig = function (config) {
      _this._userConfig = config;

      _this._setConfig(config);
    };

    _this.getConfig = function () {
      return {
        apiUri: _this._apiUri,
        rpcUri: _this._rpcUri,
        webUri: _this._webUri,
        xsUri: _this._xsUri,
        networkName: _this._networkName,
        networkId: _this._networkId,
        disableNotifications: _this._disableNotifications
      };
    };

    _this.showWidget = function () {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (enabled) {
                  _context38.next = 3;
                  break;
                }

                this._widgetEnabled = false;
                return _context38.abrupt("return", this._postMessageToChild({
                  method: 'hideWidget'
                }));

              case 3:
                this._widgetEnabled = true;
                return _context38.abrupt("return", this._postMessageToChild({
                  method: 'showWidget'
                }));

              case 5:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
    };

    _this.hideWidget = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                this._widgetEnabled = false;
                return _context39.abrupt("return", this._postMessageToChild({
                  method: 'hideWidget'
                }));

              case 2:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));
    };

    _this.widgetEnabled = function () {
      return _this._widgetEnabled;
    };

    _this.addFunds = function (opts) {
      return _this._postMessageToChild({
        method: 'addFunds',
        params: opts
      });
    };

    _this._openUrl = function () {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = opts.url,
          newWindow = opts.newWindow;

      if (newWindow) {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    };

    _this._tilIframeReady = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if (this._iframeReady) {
                  _context40.next = 4;
                  break;
                }

                _context40.next = 3;
                return utils_1.wait(100);

              case 3:
                return _context40.abrupt("return", this._tilIframeReady());

              case 4:
                _context40.next = 6;
                return utils_1.wait(100);

              case 6:
                return _context40.abrupt("return", true);

              case 7:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));
    };

    _this._tilConfigReady = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if (this._configReady) {
                  _context41.next = 4;
                  break;
                }

                _context41.next = 3;
                return utils_1.wait(100);

              case 3:
                return _context41.abrupt("return", this._tilConfigReady());

              case 4:
                _context41.next = 6;
                return utils_1.wait(100);

              case 6:
                return _context41.abrupt("return", true);

              case 7:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));
    };

    _this._tilReady = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (this.isReady()) {
                  _context42.next = 4;
                  break;
                }

                _context42.next = 3;
                return utils_1.wait(100);

              case 3:
                return _context42.abrupt("return", this._tilReady());

              case 4:
                _context42.next = 6;
                return utils_1.wait(100);

              case 6:
                return _context42.abrupt("return", true);

              case 7:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));
    };

    _this._emitReadyEvent = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return this._tilReady();

              case 2:
                if (!this._readyEmitted) {
                  _context43.next = 4;
                  break;
                }

                return _context43.abrupt("return");

              case 4:
                this._readyEmitted = true;
                this.emit('ready', {});

              case 6:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));
    };

    _this._connectToChildIframe = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        var _this5 = this;

        var iframe;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                if (!this._iframeConnecting) {
                  _context44.next = 2;
                  break;
                }

                return _context44.abrupt("return", this._iframeConnecting);

              case 2:
                this._iframeReady = false;
                this._iframeConnecting = true;
                _context44.next = 6;
                return this._getOrCreateMainIframe();

              case 6:
                iframe = _context44.sent;
                this._iframeConnection = penpal_1.default.connectToChild({
                  iframe: iframe,
                  timeout: 60e3,
                  methods: {
                    // NOTE: the postMessage penpal method should be the only method that
                    // exists.
                    postMessage: function postMessage(data) {
                      return _this5._handlePostMessage(data);
                    }
                  }
                });
                this._iframeConnecting = new Promise(function (resolve, reject) {
                  var timedout = false;
                  var timer = setTimeout(function () {
                    if (!_this5._iframeReady) {
                      timedout = true;
                      _this5._iframeConnecting = null;
                      reject(new Error('timedout'));
                    }
                  }, 6e3); // needs to be long enough for x-site to be fully loaded

                  _this5._iframeConnection.promise.then(function (child) {
                    clearTimeout(timer);

                    if (timedout) {
                      return;
                    }

                    _this5._iframeReady = true;
                    _this5._childIframeConnection = child;

                    _this5._startHeartbeat();

                    _this5._iframeConnecting = null;
                    resolve();
                  }).catch(function (err) {
                    clearTimeout(timer);

                    if (timedout) {
                      return;
                    }

                    reject(err);
                  });
                });
                return _context44.abrupt("return", this._iframeConnecting);

              case 10:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));
    };

    _this._startHeartbeat = function () {
      var reconnect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this._heartbeatStarted) {
        _this._heartbeat(reconnect);

        _this._heartbeatStarted = true;
      }
    };

    _this._heartbeat = function () {
      var reconnect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                if (!this._destroyed) {
                  _context45.next = 2;
                  break;
                }

                return _context45.abrupt("return");

              case 2:
                _context45.next = 4;
                return utils_1.wait(2e3);

              case 4:
                _context45.prev = 4;

                if (!reconnect) {
                  _context45.next = 10;
                  break;
                }

                _context45.next = 8;
                return this._connectToChildIframe();

              case 8:
                this._backoffTimeout = 1;
                return _context45.abrupt("return", this._heartbeat());

              case 10:
                _context45.next = 12;
                return this._ping();

              case 12:
                _context45.next = 21;
                break;

              case 14:
                _context45.prev = 14;
                _context45.t0 = _context45["catch"](4);

                if (!/destroy|timedout/gi.test(_context45.t0.message)) {
                  _context45.next = 21;
                  break;
                }

                _context45.next = 19;
                return utils_1.wait(this._backoffTimeout * 1e3);

              case 19:
                // exponential backoff
                this._backoffTimeout = this._backoffTimeout << 1;
                return _context45.abrupt("return", this._heartbeat(true));

              case 21:
                return _context45.abrupt("return", this._heartbeat());

              case 22:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this, [[4, 14]]);
      }));
    };

    _this._ping = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                if (!this._destroyed) {
                  _context46.next = 3;
                  break;
                }

                console.warn('Authereum instance destroyed. Message not posted to child.');
                return _context46.abrupt("return");

              case 3:
                return _context46.abrupt("return", new Promise(function (resolve, reject) {
                  var timedout = false;
                  var timer = setTimeout(function () {
                    timedout = true;
                  }, 5e3);

                  _this6._postMessageToChild({
                    method: 'ping'
                  }).then(function (pong) {
                    clearTimeout(timer);

                    if (timedout) {
                      reject(new Error('timedout'));
                      return;
                    }

                    if (pong !== 'pong') {
                      reject(new Error('Invalid response'));
                      return;
                    }

                    resolve(pong);
                  }).catch(function (err) {
                    reject(err);
                  });
                }));

              case 4:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));
    };

    _this._constructIframe = function (input) {
      var iframe = constructIframe(Object.assign(Object.assign({}, input), {
        isPreload: _this._isPreload,
        disableGoogleAnalytics: _this._disableGoogleAnalytics
      }));

      if (_this._debug) {
        iframe.style.outline = '1px solid red';
      }

      _this._injectedElements.push(iframe);

      return iframe;
    };

    _this._getConfigFromChild = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                return _context47.abrupt("return", this._postMessageToChild({
                  method: 'getConfig'
                }));

              case 1:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));
    };

    _this._postVersionToChild = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                return _context48.abrupt("return", this._postMessageToChild({
                  method: 'version',
                  params: this.version()
                }));

              case 1:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));
    };

    _this._postConfigToChild = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                return _context49.abrupt("return", this._postMessageToChild({
                  method: 'config',
                  params: {
                    apiKey: this._apiKey,
                    disableNotifications: this._disableNotifications
                  }
                }));

              case 1:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));
    };

    _this._loadAsymmetricEncryptionKeyFromChild = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.next = 2;
                return this._postMessageToChild({
                  method: 'getAsymmetricEncryptionKey'
                });

              case 2:
                this._asymmetricEncryptionKey = _context50.sent;

              case 3:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));
    };

    _this._postMessageToChild = function (payload) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                _context51.next = 2;
                return this._tilIframeReady();

              case 2:
                if (!this._destroyed) {
                  _context51.next = 4;
                  break;
                }

                throw new Error('Authereum instance destroyed.');

              case 4:
                if (this._bodyContainsIframe()) {
                  _context51.next = 10;
                  break;
                }

                this._destroyed = true;

                this._teardownEventListeners(); // ignore destroy call to already destroyed iframe


                if (!(payload.method === 'destroy')) {
                  _context51.next = 9;
                  break;
                }

                return _context51.abrupt("return");

              case 9:
                throw new Error('Authereum instance or iframe destroyed.');

              case 10:
                return _context51.abrupt("return", this._handleError(this._childIframeConnection.postMessage(payload)));

              case 11:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));
    };

    _this._handleChildLogoutEvent = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                _context52.next = 2;
                return this._resetCache();

              case 2:
                this.emit('logout', {});

              case 3:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));
    };

    _this._handleChildDappKeyExpired = function (loginKeyAddress) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                if (!(loginKeyAddress === this._cachedLoginKeyAddress)) {
                  _context53.next = 5;
                  break;
                }

                _context53.next = 3;
                return this._resetCache();

              case 3:
                this.emit('dappKeyExpired', loginKeyAddress);
                this.emit('logout');

              case 5:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));
    };

    _this._handlePostMessage = function (data) {
      try {
        var method = data.method,
            params = data.params;

        switch (method) {
          case 'onError':
            var err = params;

            _this.emit('error', err);

            _this._notifier.notify({
              type: 'error',
              message: err.message
            });

            return;

          case 'onLogout':
            return _this._handleChildLogoutEvent();

          case 'onDappKeyExpired':
            return _this._handleChildDappKeyExpired(params);

          case 'login':
            return _this.login();

          case 'setWidgetPosition':
            // const position = params
            // const { x, y } = position
            // this.iframeStyle.left = x
            // this.iframeStyle.top = y
            // this._refreshWidget()
            return;

          case 'setWidgetSize':
            {
              var size = params;
              var width = size.width,
                  height = size.height;
              _this._iframeStyle.width = width;
              _this._iframeStyle.height = height;
              return _this._refreshWidget();
            }

          case 'setWidgetStyle':
            {
              var style = params;

              for (var key in style) {
                _this._iframeStyle[key] = style[key];
              }

              return _this._refreshWidget();
            }

          case 'setNotificationWidgetSize':
            {
              var _size = params;
              var _width = _size.width,
                  _height = _size.height;
              _this._notificationIframeStyle.width = _width;
              _this._notificationIframeStyle.height = _height;
              return _this._refreshNotificationWidget();
            }

          case 'setNotificationWidgetStyle':
            {
              var _style = params;

              for (var _key in _style) {
                _this._notificationIframeStyle[_key] = _style[_key];
              }

              return _this._refreshNotificationWidget();
            }

          case 'getWindowSize':
            return _this._getWindowSize();

          case 'hideWidget':
            return _this.hideWidget();

          case 'log':
            return _this._handlePostMessageLog(params);

          case 'openUrl':
            return _this._openUrl(params);

          default:
            break;
        }
      } catch (err) {// noop
      }
    };

    _this._handlePostMessageLog = function (data) {
      if (_this._isPreload) {
        return;
      }

      var type = data.type,
          message = data.message;

      if (!type) {
        type = 'log';
      }

      console[type](message);
    };

    _this._getWindowSize = function () {
      return {
        width: _this._getWindowWidth(),
        height: _this._getWindowHeight()
      };
    };

    _this._getWindowWidth = function () {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    };

    _this._getWindowHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }; // public _setIframePositionTop = (y: number) => {
    // if (!this._iframe) return
    // this._iframe.style.top = `${y}px`
    // }


    _this._setIframePositionLeft = function (x) {
      if (!_this._iframe) return;
      _this._iframe.style.left = "".concat(x, "px");
    };

    _this._setIframeWidth = function (width) {
      if (!_this._iframe) return;
      _this._iframe.style.width = "".concat(width, "px");
    };

    _this._setIframeHeight = function (height) {
      if (!_this._iframe) return;
      _this._iframe.style.height = "".concat(height, "px");
    };

    _this._refreshWidget = function () {
      var _this$_iframeStyle = _this._iframeStyle,
          top = _this$_iframeStyle.top,
          left = _this$_iframeStyle.left,
          width = _this$_iframeStyle.width,
          height = _this$_iframeStyle.height,
          zIndex = _this$_iframeStyle.zIndex;
      if (_this._isPreload) return;
      if (!_this._iframe) return; // this._setIframePositionTop(top)
      // this._setIframePositionLeft(left)

      _this._setIframeWidth(width);

      _this._setIframeHeight(height);

      _this._iframe.style.zIndex = "".concat(zIndex || 0);
    };

    _this._refreshNotificationWidget = function () {
      var _this$_notificationIf = _this._notificationIframeStyle,
          top = _this$_notificationIf.top,
          left = _this$_notificationIf.left,
          width = _this$_notificationIf.width,
          height = _this$_notificationIf.height,
          zIndex = _this$_notificationIf.zIndex;
      if (_this._isPreload) return;
      _this._notificationIframe.style.width = "".concat(width, "px");
      _this._notificationIframe.style.height = "".concat(height, "px");
      _this._notificationIframe.style.zIndex = "".concat(zIndex || 0);
    };

    _this._loginKeyExists = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.next = 2;
                return this.getLoginKey();

              case 2:
                return _context54.abrupt("return", !!_context54.sent);

              case 3:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));
    };

    _this._accountAddressExists = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee55() {
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _context55.next = 2;
                return this.getAccountAddress();

              case 2:
                return _context55.abrupt("return", !!_context55.sent);

              case 3:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));
    };

    _this._getAccountAdminKeyNonce = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                return _context56.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'getAccountAuthKeyNonce'
                })));

              case 1:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));
    };

    _this._getAccountAuthKeyNonce = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee57() {
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                console.warn('Deprecation notice: `authereum._getAccountAuthKeyNonce()` is deprecated. Use `authereum._getAccountAdminKeyNonce()` instead.');
                return _context57.abrupt("return", this._getAccountAdminKeyNonce());

              case 2:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));
    };

    _this._executeLoginKeyMetaTx = function (tx) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                return _context58.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'executeLoginKeyMetaTx',
                  params: serializeMessageObj(tx)
                })));

              case 1:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));
    };

    _this._loadLoginKey = function (loginKey) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.next = 2;
                return this._tilReady();

              case 2:
                return _context59.abrupt("return", this._handleError(this._postMessageToChild({
                  method: 'loadLoginKey',
                  params: loginKey
                })));

              case 3:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));
    };

    _this._getAuthenticateUri = function (loginKeyAddress) {
      var encryptionKey = _this._asymmetricEncryptionKey;
      var date = new Date();
      date.setDate(date.getDate() + 30); // expire in 30 days

      var expiresAt = date.getTime() / 1e3 | 0; // NOTE: slk = sign login key

      return _this._webUri + '/?slk=' + encodeURIComponent(JSON.stringify({
        loginKey: {
          publicAddress: loginKeyAddress,
          expiresAt: expiresAt
        },
        encryptionKey: encryptionKey
      })) + '&redirect_uri=' + _this._redirectUri;
    };

    _this._getSignWithAdminKeyUri = function (message) {
      if (is_buffer_1.default(message)) {
        message = "0x".concat(message.toString('hex'));
      } // NOTE: sm = sign message


      return _this._webUri + '/?sm=' + encodeURIComponent(JSON.stringify({
        message: message
      })) + '&redirect_uri=' + _this._redirectUri;
    };

    _this._openPopupOrRedirect = function (url) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
        var _this7 = this;

        var child, isBlocked, err, shouldShowPopupOrRedirect, errMessage;
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                this.emit('openPopup', {});

                if (!this._forceRedirect) {
                  _context62.next = 4;
                  break;
                }

                window.location.href = url;
                return _context62.abrupt("return");

              case 4:
                child = this._getAuthereumPopupWindow(url);
                isBlocked = this._isAuthereumPopupBlocked(child);

                if (!(isBlocked && !this._blockedPopupRedirect)) {
                  _context62.next = 12;
                  break;
                }

                err = new Error('Disable popup blocker and try again');

                this._notifier.notify({
                  type: 'error',
                  message: err.message,
                  timeout: 5000
                });

                throw err;

              case 12:
                if (!isBlocked) {
                  _context62.next = 26;
                  break;
                }

                this.emit('popupBlocked');
                _context62.next = 16;
                return this._showConfirmPopupOrRedirectModal();

              case 16:
                shouldShowPopupOrRedirect = _context62.sent;

                if (shouldShowPopupOrRedirect) {
                  _context62.next = 21;
                  break;
                }

                errMessage = 'Popup or redirect rejected';
                this.emit('error', errMessage);
                throw new Error(errMessage);

              case 21:
                // Try to bring up a user-initiated popup. If this fails
                // fallback to a redirect
                child = this._getAuthereumPopupWindow(url);
                isBlocked = this._isAuthereumPopupBlocked(child);

                if (!isBlocked) {
                  _context62.next = 26;
                  break;
                }

                window.location.href = url;
                return _context62.abrupt("return");

              case 26:
                child.focus();
                return _context62.abrupt("return", new Promise(function (resolve, reject) {
                  var interval = setInterval(function () {
                    return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee60() {
                      var _err;

                      return _regeneratorRuntime.wrap(function _callee60$(_context60) {
                        while (1) {
                          switch (_context60.prev = _context60.next) {
                            case 0:
                              if (child.closed) {
                                cleanUp();
                                _err = new Error('Window closed');
                                this.emit('error', _err);
                                this.emit('closePopup', {});
                                reject(_err);
                              }

                            case 1:
                            case "end":
                              return _context60.stop();
                          }
                        }
                      }, _callee60, this);
                    }));
                  }, 250);
                  var timeout = setTimeout(function () {
                    cleanUp();
                    child.close();
                    doneWithError(new Error('Timedout'));
                  }, 10 * 60 * 1000);

                  var cleanUp = function cleanUp() {
                    clearInterval(interval);
                    clearTimeout(timeout);

                    _this7.emit('closePopup', {});
                  };

                  var doneWithError = function doneWithError(err) {
                    cleanUp();

                    _this7.emit('error', err);

                    reject(err);
                  };

                  var done = function done() {
                    var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    cleanUp();
                    resolve(result);
                  };

                  var handleParentMessageEvent = function handleParentMessageEvent(event) {
                    return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee61() {
                      return _regeneratorRuntime.wrap(function _callee61$(_context61) {
                        while (1) {
                          switch (_context61.prev = _context61.next) {
                            case 0:
                              if (!event.origin.includes(this._webUri)) {
                                _context61.next = 13;
                                break;
                              }

                              // this event tells parent to close child popup
                              if (event.data.close) {
                                child.close();
                                done();
                              }

                              if (!event.data.login) {
                                _context61.next = 11;
                                break;
                              }

                              done({
                                success: true
                              });
                              this.emit('login', {});
                              this._cachedIsAuthenticated = true;

                              if (!event.data.encryptedSigningKey) {
                                _context61.next = 9;
                                break;
                              }

                              _context61.next = 9;
                              return this._loadSigningKey(event.data.encryptedSigningKey);

                            case 9:
                              this._logAnalyticsEvent({
                                eventType: 'logged_in_dapp',
                                properties: {
                                  dapp_url: window.location.href
                                }
                              });

                              if (this._redirectUri !== window.location.href) {
                                window.location.href = this._redirectUri;
                              }

                            case 11:
                              if (event.data.result) {
                                done(event.data.result);

                                if (this._redirectUri !== window.location.href) {
                                  window.location.href = this._redirectUri;
                                }
                              }

                              if (event.data.error) {
                                doneWithError(new Error(event.data.error));

                                if (this._redirectUri !== window.location.href) {
                                  window.location.href = this._redirectUri;
                                }
                              }

                            case 13:
                            case "end":
                              return _context61.stop();
                          }
                        }
                      }, _callee61, this);
                    }));
                  };

                  _this7.addEventListener('message', handleParentMessageEvent, false);
                }));

              case 28:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));
    };

    _this.addEventListener = function (type, listener) {
      var useCapture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      window.addEventListener(type, listener, useCapture);

      _this._eventListeners.push({
        type: type,
        listener: listener,
        useCapture: useCapture
      });
    };

    _this._showConfirmPopupOrRedirectModal = function () {
      return _this._handleError(_this._postMessageToChild({
        method: 'showConfirmPopupOrRedirectModal'
      }));
    };

    _this._signLoginKeyRequest = function (publicAddress) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
        var url;
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                url = this._getAuthenticateUri(publicAddress);
                return _context63.abrupt("return", this._openPopupOrRedirect(url));

              case 2:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));
    };

    _this._tilDomReady = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                return _context64.abrupt("return", onDomReady());

              case 1:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64);
      }));
    }; // keep both static and normal version methods


    _this.version = function () {
      return version_1.default;
    };

    _this.isAuthenticatedSync = function () {
      return _this._cachedIsAuthenticated;
    };

    _this.getTransactionReceipt = function (txHash) {
      return _this._handleError(_this._postMessageToChild({
        method: 'getTransactionReceipt',
        params: txHash
      }));
    };

    _this.waitForTransactionReceipt = function (txHash) {
      return _this._handleError(_this._postMessageToChild({
        method: 'waitForTransactionReceipt',
        params: txHash
      }));
    };

    _this.hasRecoveryEnabled = function () {
      return _this._handleError(_this._postMessageToChild({
        method: 'hasRecoveryEnabled'
      }));
    };

    _this.getEncryptionPublicKey = function () {
      return _this._handleError(_this._postMessageToChild({
        method: 'getEncryptionPublicKey'
      }));
    };

    _this.encryptMessage = function (message) {
      return _this._handleError(_this._postMessageToChild({
        method: 'encryptMessage',
        params: message
      }));
    };

    _this.decryptMessage = function (encryptedMessage) {
      return _this._handleError(_this._postMessageToChild({
        method: 'decryptMessage',
        params: encryptedMessage
      }));
    };

    _this.isContractDeployed = function (accountAddress) {
      return _this._handleError(_this._postMessageToChild({
        method: 'isContractDeployed',
        params: accountAddress
      }));
    };

    _this._loadSigningKey = function (signingKey) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee65() {
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                if (!this._destroyed) {
                  _context65.next = 3;
                  break;
                }

                console.warn('Authereum instance destroyed. Message not posted to child.');
                return _context65.abrupt("return");

              case 3:
                return _context65.abrupt("return", this._postMessageToChild({
                  method: 'loadSigningKey',
                  params: signingKey
                }));

              case 4:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));
    };

    _this._logAnalyticsEvent = function (input) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee66() {
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                if (!this._destroyed) {
                  _context66.next = 3;
                  break;
                }

                console.warn('Authereum instance destroyed. Message not posted to child.');
                return _context66.abrupt("return");

              case 3:
                return _context66.abrupt("return", this._postMessageToChild({
                  method: 'logAnalyticsEvent',
                  params: input
                }));

              case 4:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));
    };

    _this._setupSigningKey = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee67() {
        var encryptedSigningKey, success;
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                _context67.next = 2;
                return this._tilReady();

              case 2:
                encryptedSigningKey = this._authereumQueryParams['encryptedSigningKey'];

                if (!encryptedSigningKey) {
                  _context67.next = 8;
                  break;
                }

                _context67.next = 6;
                return this._loadSigningKey(encryptedSigningKey);

              case 6:
                success = _context67.sent;

                if (success) {
                  try {
                    localStorage.removeItem('_authereum');
                  } catch (err) {// noop
                  }
                }

              case 8:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));
    };

    _this._cacheAuthereumQueryParams = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee68() {
        var param, newUrl, cached;
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                try {
                  param = utils_1.getQueryParamValue('_authereum');

                  if (param) {
                    this._authereumQueryParams = JSON.parse(param);

                    try {
                      localStorage.setItem('_authereum', btoa(JSON.stringify(this._authereumQueryParams)));
                    } catch (err) {// noop
                    }

                    newUrl = utils_1.removeQueryParam('_authereum');
                    utils_1.replaceWindowUrl(newUrl);
                  } else {
                    try {
                      // load from local storage cache if exists.
                      // this local storage is cleared after connection.
                      cached = localStorage.getItem('_authereum');

                      if (cached) {
                        this._authereumQueryParams = JSON.parse(atob(cached));
                      }
                    } catch (err) {// noop
                    }
                  }
                } catch (err) {// noop
                }

              case 1:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));
    };

    _this.destroy = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee69() {
        var i, element;
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                if (!this._destroyed) {
                  _context69.next = 3;
                  break;
                }

                console.warn('Authereum instance already destroyed.');
                return _context69.abrupt("return", true);

              case 3:
                _context69.prev = 3;

                if (!(this._iframeReady && this._bodyContainsIframe())) {
                  _context69.next = 7;
                  break;
                }

                _context69.next = 7;
                return this._postMessageToChild({
                  method: 'destroy'
                });

              case 7:
                _context69.next = 12;
                break;

              case 9:
                _context69.prev = 9;
                _context69.t0 = _context69["catch"](3);
                console.warn(_context69.t0);

              case 12:
                for (i = 0; i < this._injectedElements.length; i++) {
                  element = this._injectedElements[i];

                  try {
                    element.remove();
                  } catch (err) {
                    console.error(err);
                  }
                }
                /*
                const elements = document.querySelectorAll('[id*="authereum"]')
                for (let i = 0; i < elements.length; i++) {
                  const element = elements[i]
                  try {
                    element.remove()
                  } catch (err) {
                    console.error(err)
                  }
                }
                */


                this._iframeReady = false;
                this._destroyed = true;
                console.warn('Authereum instance destroyed.');

                this._teardownEventListeners();

                this.emit('destroy', {});
                return _context69.abrupt("return", true);

              case 19:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this, [[3, 9]]);
      }));
    };

    _this.isDestroyed = function () {
      return _this._destroyed;
    };

    _this.getAddressQrCodeDataUri = function (address) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee70() {
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                return _context70.abrupt("return", this._postMessageToChild({
                  method: 'getAddressQrCodeDataUri',
                  params: {
                    address: address
                  }
                }));

              case 1:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));
    };

    _this._loadNotificationsIframe = function (url) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee71() {
        var id, el;
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                id = 'authereum__x-notification-iframe';
                el = document.getElementById(id);

                if (!(el && el.src === url)) {
                  _context71.next = 6;
                  break;
                }

                this._notificationIframe = el;
                _context71.next = 15;
                break;

              case 6:
                if (el) {
                  el.remove();
                }

                this._notificationIframe = this._constructIframe({
                  id: id,
                  url: url
                });
                this._notificationIframe.style.top = '0';
                this._notificationIframe.style.right = '0';
                _context71.next = 12;
                return this._tilDomReady();

              case 12:
                el = document.getElementById(id);

                if (el) {
                  el.remove();
                }

                document.body.appendChild(this._notificationIframe);

              case 15:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));
    };

    _this._setDebug = function (enabled) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee72() {
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                this._debug = enabled;

                if (this._debug) {
                  this._iframe.style.outline = '1px solid red';
                  this._notificationIframe.style.outline = '1px solid red';
                } else {
                  this._iframe.style.outline = '0';
                  this._notificationIframe.style.outline = '0';
                }

              case 2:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this);
      }));
    };

    _this._userConfig = config;

    if (config instanceof Object) {
      _this._isPreload = !!config.isPreload;
      _this._disableGoogleAnalytics = !!config.disableGoogleAnalytics;
    }

    var merged = _this._checkCachedInstance(config);

    if (merged) {
      return _possibleConstructorReturn(_this, merged);
    }

    _this._init(config);

    if (window._authereumInstances) {
      window._authereumInstances.push(_assertThisInitialized(_assertThisInitialized(_this)));
    }

    return _this;
  }

  _createClass(Authereum, [{
    key: "_checkCachedInstance",
    value: function _checkCachedInstance(config) {
      var cachedInstance = null;

      if (Array.isArray(window._authereumInstances)) {
        if (window._authereumInstances.length) {
          cachedInstance = window._authereumInstances.pop();
        }
      } // checks if preloaded cached iframe matches the same network as user created
      // instance, and if so then merge the state to use preloaded iframe.


      if (cachedInstance) {
        if (cachedInstance.isReady()) {
          if (typeof config === 'string') {
            if (cachedInstance.getCachedNetworkName() === config) {
              return this._merge(cachedInstance);
            } else {
              cachedInstance.destroy();
              cachedInstance = null;
            }
          } else if (config instanceof Object) {
            if (cachedInstance.getCachedNetworkName() === config.networkName && !config.xsUri) {
              return this._merge(cachedInstance);
            } else {
              cachedInstance.destroy();
              cachedInstance = null;
            }
          }
        } else {
          cachedInstance.destroy();
          cachedInstance = null;
        }
      }
    } // this merges an authereum instance with this one
    // by copying all properties and connected iframes.

  }, {
    key: "_merge",
    value: function _merge(instance) {
      var _this8 = this;

      this._debug = instance._debug;
      this._apiKey = instance._apiKey;
      this._apiUri = instance._apiUri;
      this._rpcUri = instance._rpcUri;
      this._webUri = instance._webUri;
      this._xsUri = instance._xsUri;
      this._notifierUri = instance._notifierUri;
      this._networkName = instance._networkName;
      this._networkId = instance._networkId;
      this._redirectUri = instance._redirectUri;
      this._iframeConnection = instance._iframeConnection;
      this._childIframeConnection = instance._childIframeConnection;
      this._iframe = instance._iframe;
      this._notificationIframe = instance._notificationIframe;
      this._cacheReady = instance._cacheReady;
      this._cachedLoginKeyAddress = instance._cachedLoginKeyAddress;
      this._cachedAccountAddress = instance._cachedAccountAddress;
      this._cachedIsAuthenticated = instance._cachedIsAuthenticated;
      this._iframeReady = instance._iframeReady;
      this._configReady = instance._configReady;
      this._iframeStyle = instance._iframeStyle;
      this._notificationIframeStyle = instance._notificationIframeStyle;
      this._heartbeatStarted = instance._heartbeatStarted;
      this._backoffTimeout = instance._backoffTimeout;
      this._asymmetricEncryptionKey = instance._asymmetricEncryptionKey;
      this._authereumQueryParams = instance._authereumQueryParams;
      this._injectedElements = instance._injectedElements;
      this._notificationsMap = instance._notificationsMap;
      instance._handlePostMessage = this._handlePostMessage.bind(instance);

      this._initConfig(this._userConfig);

      this._cacheLoginKeyAddress();

      this._getConfigFromChild().then(function (config) {
        _this8._setConfig(config);

        _this8._postConfigToChild().catch(noop);

        _this8.emit('iframeReady', {});
      }).catch(noop);

      this._emitReadyEvent();

      this._provider = new AuthereumProvider_1.default(this);

      this._refreshWidget();

      return this;
    }
  }, {
    key: "_setupFocusListener",
    value: function _setupFocusListener() {
      this.addEventListener('focus', this._handleWindowFocus, false);
    }
  }, {
    key: "_setupActionKeyListener",
    value: function _setupActionKeyListener() {
      this.addEventListener('keydown', this._handleActionKeyPress, false);
    }
  }, {
    key: "_teardownEventListeners",
    value: function _teardownEventListeners() {
      for (var i = 0; i < this._eventListeners.length; i++) {
        var _this$_eventListeners = this._eventListeners[i],
            type = _this$_eventListeners.type,
            listener = _this$_eventListeners.listener,
            useCapture = _this$_eventListeners.useCapture;
        window.removeEventListener(type, listener, useCapture);
      }
    }
  }, {
    key: "_getOrCreateMainIframe",
    value: function _getOrCreateMainIframe() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee74() {
        var _this9 = this;

        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                if (this._iframe) {
                  if (this._iframeConnection) {
                    this._iframeConnection.destroy();
                  }

                  this._iframe.remove();
                }

                return _context74.abrupt("return", new Promise(function (resolve) {
                  return __awaiter(_this9, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee73() {
                    var _this10 = this;

                    var id, el, notificationIframeUrl;
                    return _regeneratorRuntime.wrap(function _callee73$(_context73) {
                      while (1) {
                        switch (_context73.prev = _context73.next) {
                          case 0:
                            id = 'authereum__x-iframe';
                            el = document.getElementById(id);

                            if (!(el && el.src === this._xsUri)) {
                              _context73.next = 6;
                              break;
                            }

                            this._iframe = el;
                            _context73.next = 16;
                            break;

                          case 6:
                            this._iframe = this._constructIframe({
                              id: id,
                              url: this._xsUri
                            });
                            notificationIframeUrl = "".concat(this._xsUri.replace(/\/$/, ''), "/notifications");

                            this._loadNotificationsIframe(notificationIframeUrl).catch(noop);

                            resolve(this._iframe);
                            _context73.next = 12;
                            return this._tilDomReady();

                          case 12:
                            el = document.getElementById(id);

                            if (el) {
                              el.remove();
                            }

                            document.body.appendChild(this._iframe);

                            this._iframe.onload = function () {
                              _this10._postVersionToChild().catch(noop);

                              _this10._loadAsymmetricEncryptionKeyFromChild().catch(noop);

                              _this10._getConfigFromChild().then(function (config) {
                                if (notificationIframeUrl !== config.notifierIframeUri) {
                                  _this10._loadNotificationsIframe(config.notifierIframeUri);
                                }

                                _this10._setConfig(config);

                                _this10._postConfigToChild().catch(noop);

                                _this10._configReady = true;

                                _this10.emit('iframeReady', {});
                              }).catch(noop);
                            };

                          case 16:
                          case "end":
                            return _context73.stop();
                        }
                      }
                    }, _callee73, this);
                  }));
                }));

              case 2:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, this);
      }));
    }
  }, {
    key: "_bodyContainsIframe",
    value: function _bodyContainsIframe() {
      return document.body.contains(this._iframe);
    }
  }, {
    key: "_getAuthereumPopupWindow",
    value: function _getAuthereumPopupWindow(url) {
      return window.open(url, 'Authereum', "toolbar=no,\n      location=no,\n      status=no,\n      menubar=no,\n      scrollbars=no,\n      resizable=no,\n      width=470,\n      height=640");
    }
  }, {
    key: "_isAuthereumPopupBlocked",
    value: function _isAuthereumPopupBlocked(child) {
      return child === null || child === undefined;
    }
  }, {
    key: "isPreload",
    value: function isPreload() {
      return this._isPreload;
    }
  }]);

  return Authereum;
}(eventemitter3_1.default);

exports.default = Authereum; // keep both static and normal version methods

Authereum.version = function () {
  return version_1.default;
};

if (typeof window !== 'undefined') {
  window.Authereum = Authereum;
  window._authereumInstances = []; // disable preloading if param set for debugging
  // if (!getQueryParamValue('debug_disable_preload')) {

  if (utils_1.getQueryParamValue('authereum_debug')) {
    // preload instance in order to avoid async calls between
    // user action and login call.
    var cachedNetwork = 'mainnet';
    var networks = ['kovan', 'goerli', 'rinkeby', 'ropsten'];

    for (var i = 0; i < networks.length; i++) {
      // assuming which network to preload
      if (window.location.href.includes(networks[i])) {
        cachedNetwork = networks[i];
        break;
      }
    }

    var cachedInstance = new Authereum({
      networkName: cachedNetwork,
      isPreload: true
    });

    window._authereumInstances.push(cachedInstance);
  }
}